import {EAppMode, ELanguage, Podcast} from '@microfrontends/react-components'
import React, { useState, useEffect } from 'react'

export enum EType {
    LARGE = 'large',
    MEDIUM = 'medium',
    SMALL = 'small'
}

const PodcastAudio = ({ language }) => {
    /**
     * VNW-23152 [Web][NaviCMS] Update podcast
     *
     * @author HieuNPM
     * @since Jul 10 2023
     */

    const mode = process.env.APP_MODE as EAppMode
    const podcastApi = process.env.PODCAST_API as string;
    const emptyPodcast = { title: '', time: '', link: '', url: '', utm: '', image: ''}
    const [podcastData, setPodcastData] = useState(emptyPodcast);

    useEffect(() => {
        ;(async () => {
            const podcastRes = await fetch(podcastApi)
            const podcasts = await podcastRes.json()

            if (!Array.isArray(podcasts) || podcasts.length === 0) { return }

            let item = podcasts.pop()
            let date = new Date(item.publishedOn)

            // 'Apr 7' || '7 tháng 4'
            let displayTime = language === ELanguage.EN
                ? `${date.toLocaleString('en', { month: 'short' })} ${date.getDate()}`
                : `${date.getDate()} ${date.toLocaleString('vi', { month: 'long' })}`

            const podcastData = {
                title: item.title,
                time: displayTime,
                link: item.source,
                url: item.url,
                utm: item.utm,
                image: item.thumbnail
            }
            setPodcastData(podcastData)
        })()

    }, [])

    return process.env.ENABLE_SPOTIFY ? <Podcast type={EType.SMALL} language={language} appMode={mode} podcastData={podcastData} /> : null
}

export default PodcastAudio
